module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/instagram/suns_sns_05-249beecb4115a8db135a6df973cd0804.jpg";